import FormattedMessage from 'I18n/components/FormattedMessage';
import UILink from 'UIComponents/link/UILink';
import UIResultsMessage from 'UIComponents/results/UIResultsMessage';
import { H4 } from 'UIComponents/elements/headings';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function ToolAccessApprovalSentResult(props) {
  const {
    approver
  } = props;
  return /*#__PURE__*/_jsxs(UIResultsMessage, {
    "data-test-id": "tool-access-approval-sent-result",
    illustration: "successful-send",
    title: /*#__PURE__*/_jsx(H4, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "toolAccess.requestSent"
      })
    }),
    children: [/*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "toolAccess.requestSentToApprover",
        options: Object.assign({}, approver)
      })
    }), /*#__PURE__*/_jsx(UILink, {
      href: "/",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "toolAccess.goToHome"
      })
    })]
  });
}
export default ToolAccessApprovalSentResult;